import React, { useEffect } from 'react';
import HeadingOne from '../../components/HeadingOne';

const PrivacyStatementPage = () => {
    useEffect(() => {
        document.title = `Privacyverklaring - Private Gym Schijndel`;
    }, []);

    return (
        <>
            <section className="hero concept-hero">
                <div className="default-container flex justify-center items-center h-full w-full">
                    <div className="text-center">
                        <HeadingOne>
                            Privacyverklaring.
                        </HeadingOne>
                        <h3 className="text-primary-500 pt-2 pb-16">De privacyverklaring van Private Gym Schijndel.</h3>
                    </div>
                </div>
            </section>

            <section className="medium-container">
                <p className="p1 pt-6 pb-2"><strong>PRIVACYVERKLARING &ndash; NS PERFORMANCE / PRIVATE GYM</strong></p>
                <p className="p1 pt-6 pb-2"><strong>SCHIJNDEL</strong></p>
                <p className="p2">Bij <strong>NS PERFORMANCE</strong>, opererend onder de naam <strong>Private Gym
                    Schijndel</strong>, hechten wij veel</p>
                <p className="p2">waarde aan jouw privacy. In deze privacyverklaring lees je welke persoonsgegevens
                    wij</p>
                <p className="p2">verzamelen, voor welke doeleinden, hoe wij deze beveiligen en welke rechten je hebt
                    volgens de</p>
                <p className="p2">Algemene Verordening Gegevensbescherming (AVG).</p>
                <p className="p1 pt-6 pb-2"><strong>1. Wie zijn wij?</strong></p>
                <p className="p2"><strong>NS PERFORMANCE</strong> &ndash; Private Gym Schijndel</p>
                <p className="p2">Ericastraat 3, 5482 WE Schijndel</p>
                <p className="p2">E-mail: info@privategym-schijndel.nl</p>
                <p className="p2">Telefoon: +31 6 83371313</p>
                <p className="p2">NS PERFORMANCE is verwerkingsverantwoordelijke in de zin van de AVG.</p>
                <p className="p1 pt-6 pb-2"><strong>2. Welke persoonsgegevens verwerken wij?</strong></p>
                <p className="p2">Afhankelijk van je relatie met ons, kunnen wij de volgende gegevens verzamelen en
                    verwerken:</p>
                <p className="p2"><span className="s1">&bull;</span> Voor- en achternaam</p>
                <p className="p2"><span className="s1">&bull;</span> Adres en woonplaats</p>
                <p className="p2"><span className="s1">&bull;</span> Telefoonnummer en e-mailadres</p>
                <p className="p2"><span className="s1">&bull;</span> Geboortedatum</p>
                <p className="p2"><span className="s1">&bull;</span> Gezondheidsgegevens (uitsluitend met jouw
                    expliciete toestemming)</p>
                <p className="p2"><span className="s1">&bull;</span> Aantekeningen vanuit intake of begeleiding</p>
                <p className="p2"><span className="s1">&bull;</span> IP-adres (bij gebruik van onze website)</p>
                <p className="p1 pt-6 pb-2"><strong>3. Voor welke doeleinden gebruiken wij deze gegevens?</strong></p>
                <p className="p2">Wij verwerken jouw gegevens uitsluitend voor de volgende legitieme doeleinden:</p>
                <p className="p2"><span className="s1">&bull;</span> Het opstellen van een persoonlijk trainings- en/of
                    voedingsplan</p>
                <p className="p2"><span className="s1">&bull;</span> Het uitvoeren van afspraken, trainingen en
                    administratieve verwerking (zoals facturatie)</p>
                <p className="p2"><span className="s1">&bull;</span> Communicatie over roosterwijzigingen, afmeldingen
                    of planning</p>
                <p className="p2"><span className="s1">&bull;</span> Voldoen aan wettelijke verplichtingen (bijv.
                    fiscale administratie)</p>
                <p className="p2"><span className="s1">&bull;</span> Veiligheid en beheer van onze systemen en website
                </p>
                <p className="p1 pt-6 pb-2"><strong>4. Rechtsgrond voor verwerking</strong></p>
                <p className="p2">De verwerking van jouw persoonsgegevens vindt plaats op basis van:</p>
                <p className="p2"><span className="s1">&bull;</span> De uitvoering van een overeenkomst (bijvoorbeeld
                    een personal trainingstraject)</p>
                <p className="p2"><span className="s1">&bull;</span> Jouw uitdrukkelijke toestemming (bijvoorbeeld voor
                    het verwerken van</p>
                <p className="p2">gezondheidsgegevens)<span className="s1">&bull;</span> Voldoen aan wettelijke
                    verplichtingen (zoals belastingwetgeving)</p>
                <p className="p2"><span className="s1">&bull;</span> Gerechtvaardigd belang (zoals beveiliging,
                    klantbeheer en kwaliteitsverbetering)</p>
                <p className="p1 pt-6 pb-2"><strong>5. Verstrekking aan derden</strong></p>
                <p className="p2">Jouw gegevens worden uitsluitend gedeeld met derden als dit strikt noodzakelijk is
                    voor:</p>
                <p className="p2"><span className="s1">&bull;</span> Onze boekhouder of belastingadviseur</p>
                <p className="p2"><span className="s1">&bull;</span> Een incassobureau bij wanbetaling</p>
                <p className="p2"><span className="s1">&bull;</span> Softwareleveranciers voor administratie, planning
                    of communicatie (alleen met</p>
                <p className="p2">verwerkersovereenkomst)</p>
                <p className="p2">Wij verkopen jouw gegevens nooit aan derden.</p>
                <p className="p1 pt-6 pb-2"><strong>6. Beveiliging van jouw gegevens</strong></p>
                <p className="p2">NS PERFORMANCE / Private Gym Schijndel neemt passende technische en
                    organisatorische</p>
                <p className="p2">beveiligingsmaatregelen om jouw gegevens te beschermen tegen verlies, misbruik,
                    onbevoegde</p>
                <p className="p2">toegang of wijziging. Alleen bevoegde medewerkers hebben toegang tot jouw
                    gegevens.</p>
                <p className="p1 pt-6 pb-2"><strong>7. Bewaartermijnen</strong></p>
                <p className="p2"><span className="s1">&bull;</span> <strong>Persoonsgegevens</strong>: tot maximaal 2
                    jaar na be&euml;indiging van de overeenkomst</p>
                <p className="p2"><span className="s1">&bull;</span> <strong>Facturatiegegevens</strong>: minimaal 7
                    jaar (conform fiscale bewaarplicht)</p>
                <p className="p2"><span className="s1">&bull;</span> <strong>Gezondheidsgegevens</strong>: tot direct na
                    be&euml;indiging van de dienstverlening, tenzij je</p>
                <p className="p2">expliciet toestemming geeft voor langere bewaring (bijv. bij hervatting)</p>
                <p className="p1 pt-6 pb-2"><strong>8. Jouw rechten als betrokkene</strong></p>
                <p className="p2">Je hebt het recht om:</p>
                <p className="p2"><span className="s1">&bull;</span> Inzage te krijgen in de persoonsgegevens die wij
                    van jou verwerken</p>
                <p className="p2"><span className="s1">&bull;</span> Gegevens te laten corrigeren of verwijderen</p>
                <p className="p2"><span className="s1">&bull;</span> Verwerking tijdelijk te beperken</p>
                <p className="p2"><span className="s1">&bull;</span> Gegevens over te dragen (dataportabiliteit)</p>
                <p className="p2"><span className="s1">&bull;</span> Eerder gegeven toestemming in te trekken</p>
                <p className="p2"><span className="s1">&bull;</span> Klacht in te dienen bij de Autoriteit
                    Persoonsgegevens via</p>
                <p className="p3">www.autoriteitpersoonsgegevens.nl</p>
                <p className="p2">Je kunt een verzoek tot uitoefening van deze rechten indienen
                    via: <strong>info@privategym-</strong></p>
                <p className="p2"><strong>schijndel.nl</strong></p>
                <p className="p1 pt-6 pb-2"><strong>9. Cookies en websitegebruik</strong></p>
                <p className="p2">Onze website maakt uitsluitend gebruik van functionele en analytische cookies. Deze
                    worden</p>
                <p className="p2">niet gebruikt voor tracking of commerci&euml;le doeleinden.
                </p>

                <p className="pt-6 pb-2"><strong>10. Wijzigingen in deze privacyverklaring</strong></p>
                <p className="p2">Deze privacyverklaring kan door NS PERFORMANCE / Private Gym Schijndel worden</p>
                <p className="p2">gewijzigd. De meest actuele versie is altijd beschikbaar via onze website of op
                    aanvraag.</p>
            </section>
        </>
    )
}

export default PrivacyStatementPage;
